import { computed } from "vue";

export function useQuasarCarousel(properties, options = {}) {
  // Default options
  const config = {
    groupSize: options.groupSize || 1,
    addSeeOfferCard: options.addSeeOfferCard ?? true,
    includePreview: options.includePreview ?? false,
  };

  // Dynamically create slides based on offers
  const offerArray = computed(() => {
    const array = [];
    const offers = properties.getMatchedOffers();

    for (let index = 0; index < offers.length; index += config.groupSize) {
      const pair = offers.slice(index, index + config.groupSize);

      // Optional preview logic
      if (config.includePreview) {
        const nextPreview = offers[index + config.groupSize] || null;
        array.push(nextPreview ? [...pair, nextPreview] : pair);
      } else {
        array.push(pair);
      }
    }

    // Optionally add dummy slide for "SeeOfferCard"
    if (config.addSeeOfferCard) {
      array.push([{ isSeeOfferCard: true }]);
    }

    return array;
  });

  return {
    getOfferArray: () => offerArray.value,
  };
}
